<script setup lang="ts">
import { GpBrandMessage } from '@gportal/uikit';
</script>

<template>
  <GpBrandMessage class="tw-mx-auto tw-mt-4">
    <p class="tw-font-bold tw-uppercase">
      <slot></slot>
    </p>
  </GpBrandMessage>
</template>

<style scoped></style>
